import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import partners from "../../../api/partners";
import "./index.css"

var settings = {
  dots: false,
  infinite: true,
  speed: 5000,
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  arrows: false,

  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 350,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const FeaturePartners = (props) => {
  return (
    <div className="feature_partners_section_methodology">
      <div className="container position-relative p-partnerList">
        <div className="p-partner title_text text-white">
        Collaborating with clients, using innovative tech, backed by certified expertise.
        </div>
        <div className="client_logo_carousel client_logo_item_bg">
          <Slider {...settings}>
            {partners.map((partner, pitem) => (
              <div className="client_logo_item " key={pitem}>
                <img src={partner.pImg}  width={100} height={100} alt="Techco - Client Logo"/>
              </div>
            ))}
          </Slider>

         </div>
      </div>
    </div>
  );
};

export default FeaturePartners;
